import React from "react";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";
import { all_routes } from "../router/all_routes";

const Footer = () => {
  const route = all_routes;
  const currentYear = new Date().getFullYear();

  return (
    <footer className="lux-footer-wrapper">
      <div className="container">
        
        {/* Top/Main Footer Area */}
        <div className="lux-footer-main">
          <div className="row">
            
            {/* Column 1: Brand */}
            <div className="col-lg-4 col-md-12 mb-5 mb-lg-0 lux-footer-brand">
              <h2 className="lux-footer-logo-text">ELEEGO</h2>
              <p className="lux-footer-desc">
                Your premier partner in luxury travel. Experience unparalleled comfort, 
                elegance, and sophistication with our exclusive fleet in Geneva, Switzerland.
              </p>
            </div>

            {/* Column 2: Navigation */}
            <div className="col-lg-4 col-md-6 mb-5 mb-md-0 lux-footer-nav">
              <h6 className="lux-footer-heading">Discover</h6>
              <div className="row">
                <div className="col-6">
                  <ul className="lux-footer-links">
                    <li><Link to={route.home}>Home</Link></li>
                    <li><Link to={route.services}>Services</Link></li>
                    <li><Link to={route.aboutus}>About Us</Link></li>
                  </ul>
                </div>
                <div className="col-6">
                  <ul className="lux-footer-links">
                    <li><Link to={`${route.listinggrid}?category=limousine`}>Limousine</Link></li>
                    <li><Link to={`${route.listinggrid}?category=rental`}>Rental Cars</Link></li>
                    <li><Link to={route.contact}>Contact Us</Link></li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Column 3: Contact & Social */}
            <div className="col-lg-4 col-md-6 lux-footer-contact">
              <h6 className="lux-footer-heading">Contact</h6>
              <ul className="lux-footer-links">
                <li><a href="tel:+41782396850">+41 78 239 68 50</a></li>
                <li><a href="mailto:info@eleego.ch">info@eleego.ch</a></li>
              </ul>
              
              <div className="lux-footer-socials mt-4">
                <a href="https://www.facebook.com/profile.php?id=61553772887408&mibextid=LQQJ4d" target="_blank" rel="noreferrer">
                  <i className="fa-brands fa-facebook-f" />
                </a>
                <a href="https://www.instagram.com/eleego?igsh=MWhhanB3MHh3a2Mxag==" target="_blank" rel="noreferrer">
                  <i className="fab fa-instagram" />
                </a>
              </div>
            </div>
            
          </div>
        </div>

        {/* Bottom/Copyright Area */}
        <div className="lux-footer-bottom">
          <div className="row align-items-center">
            <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
              <p className="lux-copyright">
                &copy; {currentYear} ELEEGO. ALL RIGHTS RESERVED.
              </p>
            </div>
            <div className="col-md-6 text-center text-md-end">
              <div className="lux-payment-icons">
                <ImageWithBasePath src="assets/img/icons/paypal.svg" alt="PayPal" />
                <ImageWithBasePath src="assets/img/icons/visa.svg" alt="Visa" />
                <ImageWithBasePath src="assets/img/icons/master.svg" alt="Mastercard" />
                <ImageWithBasePath src="assets/img/icons/applegpay.svg" alt="Apple Pay" />
              </div>
            </div>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
